module.exports = __webpack_public_path__ + "img/kedah.1c9da4c6.png";